var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loadingVue"},[_c('van-loading',{attrs:{"type":"spinner","size":"30px","color":"#fff"}}),_c('span',[_vm._v(_vm._s(_vm.$t("head.jj1"))+"...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }